var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binding"},[_vm._v(" "+_vm._s(_vm.bindingText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }